/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [
  {
    key: 'tips',
    value: '商品链接可以拖拽改变顺序',
    type: 'tips',
  },
  {
    name: '商品',
    type: 'module-name',
  },
  {
    key: 'style_type',
    name: '样式',
    type: 'radio-box-img',
    width: 84,
    'radio-list': [
      {
        url:
          'https://img.mockuai.com/tms/2018/1/10/upload_45d9acc229960a30ca9b14ab951d0986.png',
        value: 1,
        text: '双列有边距',
      },
      {
        url:
          'https://img.mockuai.com/tms/2018/1/10/upload_c9b8a668b7812c4277a638986eab1e93.png',
        value: 2,
        text: '单列有间距',
      },
      {
        url:
          'https://img.mockuai.com/tms/2018/1/10/upload_0e22c83e15505e62389bcc0d9868a458.png',
        value: 3,
        text: '三列',
      },
    ],
  },
  {
    key: 'bg_color',
    name: '卡片背景色',
    type: 'color',
  },
  {
    key: 'font_color',
    name: '文案颜色',
    type: 'color',
  },
  {
    key: 'price_font_color',
    name: '价格颜色',
    type: 'color',
  },
  {
    key: 'btn_bg_color',
    name: '按钮背景色',
    type: 'color',
  },
  {
    key: 'btn_font_color',
    name: '按钮文案颜色',
    type: 'color',
  },
  {
    key: 'tips_bg_color',
    name: '标签背景色',
    type: 'color',
  },
  {
    key: 'tips_color',
    name: '标签文案',
    type: 'color',
  },
  {
    key: 'property_data',
    name: '属性',
    type: 'custom',
    content: [
      {
        key: 'btn_text',
        name: '按钮文案',
        type: 'text',
      },
      // {
      //   "key": 'btn_bg',
      //   "name": "主题色",
      //   "type": "color",
      //  }
    ],
  },
  {
    key: 'active_item',
    name: '选择活动',
    type: 'select-active',
  },
  {
    key: 'link_data',
    name: '选择商品',
    type: 'active-goods-item',
  },
];

export default config;
